<template>
 <div class="bg-green">

    <header>
     
     <div
       class="d-none"
       v-for="(step, index) in formGroup"
       :key="'step'+index"
     >
    {{formPosition}}
   {{formPosition + 1}}
      
       {{formGroup.length}}
        {{formGroup.length - 1 }}
     </div>
     
    </header>
    <section :class="animation">
               <div class="container bg-green">
        <div class="row w-100">
          <div class="col-30 mx-auto text-center text-white position-relative">
   
      <div v-if="formPosition === 0 ">

            <h1 class="">Search Here for</h1>
            <div class="fs-1  mb-5">Alcohol & Other Drugs +<br>Mental Health Service Providers</div>
            <div>LET US GUIDE YOU TO A SERVICE THAT MAY ASSIST YOU. </div>
            <div>Follow these easy steps to find a Service that is right for you</div>
            <div class="bigbtn shadow  btn d-flex flex-row bg-white rounded-3 px-5 py-3 mx-auto my-7" @click="nextStep"><h2 class="text-green">Get Started</h2><svg xmlns="http://www.w3.org/2000/svg" fill="green" class="bi bi-arrow-right" height="3.5rem" width="3rem" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z"/>
</svg></div>
         </div>
 
      <div class="bg-green" v-if="formPosition === 1 ">
       <div class="container">
  <div class="row">
    <div class="col-48 position-relative slider-container d-flex flex-column  justify-content-center ">
   

<div class="white-circle"></div>
<div class="slider-intro mx-auto"><h3 class="text-green">What type of Service
are you looking for?</h3><p>SELECT FROM ONE OF THE OPTIONS BELOW</p>
</div>
  <Carousel :itemsToShow="3" :wrapAround="true">
    <Slide v-for="image in images" :key="image.id">
      <div class="carousel__item d-flex flex-column">
           <img :src="image.url" />
           <button class="btn btn-primary" @click="getValue(image.type)">{{image.type}}</button>
           </div>
    </Slide>
    <template #addons>
    <Navigation  />
  </template>
  </Carousel>



      </div>
  </div>
</div>
      </div>

  <div class="bg-green d-flex flex-column" v-if="formPosition === 2 ">
<div>
    <input type="number" min="6" max="6" value="6" disabled>
<input id="pc2" type="number" min="0" max="9" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" maxlength="1">
<input id="pc3" type="number" min="0" max="9" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" maxlength="1">
<input id="pc4" type="number" min="0" max="9" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" maxlength="1" @change="handleClick">
</div>

 <router-link  class="text-decoration-none text-center d-flex flex-column align-items-center justify-content-start p-5 text-green fw-bold btn-secondary" :to="{name: 'Search', params: { org: newCategory}, query: { postcode: this.postcode, category: newCategory } }">
             SEARCH
          </router-link>

           <router-link  class="text-decoration-none text-center d-flex flex-column align-items-center justify-content-start p-5 text-green fw-bold btn-danger" :to="{name: 'Search', params: { org: newCategory}, query: { category: newCategory } }">
             OR VIEW ALL IN WESTERN AUSTRALIA
          </router-link>
      </div>

       </div>
      </div>
      </div>
   
   </section>
 
   </div>
</template>
<script>
import Vslide from '@/components/Vslide';
import { defineComponent } from 'vue';
import { Carousel, Pagination, Slide, Navigation } from 'vue3-carousel';
import json from '@/stores/PostcodeStore.json'
import 'vue3-carousel/dist/carousel.css';
export default {
 name: 'Slider',
  components: {
    Carousel,
    Slide,
    Pagination,
      Navigation,
  },
  data: () => {
    return {

    lat:'',
    lng:'',
    postcode:'',
    postcodeJson: json.postcodeJson,
    images : [
      { id: 1, url: "https://picsum.photos/300/200?q=1", type:"outreach" },
      { id: 2, url: "https://picsum.photos/300/200?q=2", type:"information"},
      { id: 3, url: "https://picsum.photos/300/200?q=3", type:"finance" },
      { id: 4, url: "https://picsum.photos/300/200?q=4", type:"volunteer"},
    ],
    // carousel settings
    settings: {
      itemsToShow: 1,
      snapAlign: 'center',
    },
    // breakpoints are mobile first
    // any settings not specified will fallback to the carousel settings
    breakpoints: {
      // 700px and up
      700: {
        itemsToShow: 3.5,
        snapAlign: 'center',
      },
      1024: {
        itemsToShow: 2,
        snapAlign: 'center',
      },
    },

             formPosition: 0,
             animation: 'animate-in',
             formGroup: [
               {title: "Personal Details"},
               {title: "What type of Service are you looking for?"},
               {title: "What is your postcode?"},
                ]}},
  methods: {
     nextStep(){
      this.animation = 'animate-out';
      setTimeout(() => {
      this.animation = 'animate-in';
      this.formPosition += 1;
     }, 600);
     },
          getValue(value){
            this.newCategory = value;
           console.log(value);
          
      this.animation = 'animate-out';
      setTimeout(() => {
      this.animation = 'animate-in';
      this.formPosition += 1;
     }, 600);
     },


     
      handleClick() {
       const pc1 = 6
       const pc2 = document.getElementById("pc2").value;
       const pc3 = document.getElementById("pc3").value;
       const pc4 = document.getElementById("pc4").value;
       const postcode = parseInt(pc1 + pc2 + pc3 + pc4);
       this.postcode = postcode
       console.log(postcode);
       const getFruit = this.postcodeJson.find(item => item.postcode === postcode);
       console.log(getFruit.lat);
       console.log(getFruit.lng);
       this.lat = getFruit.lat;
       this.lng = getFruit.lng;
    },
     }
  }
</script>
<style>
.animation-in {
   transform-origin: left;
   animation: in .6s ease-in-out;
}
.animation-out {
   transform-origin: bottom left;
   animation: out .6s ease-in-out;
}


.bigbtn {
    width: 23rem;
}

.carousel__prev,
.carousel__next {
  background-color: white;
  border-radius: 30px;
  width: 30px;
  height: 30px;
  text-align: center;
  font-size: 1rem;
  padding: 0;
  color: red;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  border: 0;
  cursor: pointer;
}

.carousel__prev {
  top: 50%;
  left: 0;
  transform: translate(-50%, -50%);
}

.carousel__next {
  top: 50%;
  right: 0;
  transform: translate(50%, -50%);
}

.carousel--rtl .carousel__prev {
  left: auto;
  right: 0;
  transform: translate(50%, -50%);
}

.carousel--rtl .carousel__next {
  right: auto;
  left: 0;
  transform: translate(-50%, -50%);
}

.carousel__icon {
  width: 1rem;
  height: 1rem;
  fill: red;
}
.carousel {
  position: relative;
  text-align: center;
  box-sizing: border-box;
}

.carousel * {
  box-sizing: border-box;
}

.carousel__track {
  display: flex;
  margin: 0;
  padding: 0;
  position: relative;
}

.carousel__viewport {
  overflow: hidden;
}
.carousel__pagination {
  display: flex;
  justify-content: center;
  list-style: none;
}

.carousel__slide {
  scroll-snap-stop: auto;
  flex-shrink: 0;
  margin: 0;
  position: relative;

  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
